import { track } from "../track";

export const trackSignUpScs = (params: {
  email: string;
  name?: string;
  quiz_id?: string;
}) => track({ event: "sign_up_scs", ...params });
